// ./src/components/features/EventGuests/AnswerPicture.tsx
//
// A2e #91 — a PICTURE answer (a guest's photo, a partner's logo), shown as a small thumbnail that opens the full picture.
// Used wherever a host reads answers: the Answers matrix, the approval review drawer, a sponsorship or volunteer
// application. The text views (`formatAnswer`) carry the picture's link instead.
import React from "react";
import { Anchor, Image } from "@mantine/core";

import { type AnswerPictureSource } from "./answerFormat";

export const AnswerPicture: React.FC<{ picture: AnswerPictureSource; label?: string | null }> = ({ picture, label }) => (
  <Anchor href={picture.href} target="_blank" rel="noopener noreferrer" aria-label={label ? `Open the picture: ${label}` : "Open the picture"}>
    <Image src={picture.src} h={64} w="auto" fit="contain" radius="sm" alt={label ?? ""} style={{ maxWidth: 160 }} />
  </Anchor>
);
